<template>
  <div class="filters">
    <p class="filter-label">
      Filter:
    </p>

    <Button
      class="link filter-link"
      :title="disabledTitle"
      :class="{ active: status === 'ALL' }"
      :disabled="disabled || status === 'ALL'"
      @click="$emit('filter-selected', 'ALL')"
    >
      All
    </Button>

    <Button
      class="link filter-link"
      :title="disabledTitle"
      :class="{ active: status === 'DRAFT' }"
      :disabled="disabled || status === 'DRAFT'"
      @click="$emit('filter-selected', 'DRAFT')"
    >
      Draft
    </Button>

    <Button
      class="link filter-link"
      :title="disabledTitle"
      :class="{ active: status === 'SENDING' }"
      :disabled="disabled || status === 'SENDING'"
      @click="$emit('filter-selected', 'SENDING')"
    >
      Sending
    </Button>

    <Button
      class="link filter-link"
      :title="disabledTitle"
      :class="{ active: status === 'SENT' }"
      :disabled="disabled || status === 'SENT'"
      @click="$emit('filter-selected', 'SENT')"
    >
      Sent
    </Button>
  </div>
</template>

<script>
export default {
  name: "CampaignListFilters",
  props: {
    disabled: {
      type: Boolean,
      default: true,
    },
    status: {
      type: String,
      default: "",
    },
  },
  computed: {
    disabledTitle() {
      return this.disabled ? "Loading..." : "";
    },
  },
};
</script>

<style scoped>
.filters {
  @apply flex items-center mb-6 justify-center;

  @screen sm {
    @apply justify-end;
  }
}

.filter-label {
  @apply m-0 text-grey-darker text-xxs;
}

.filter-link {
  @apply ml-2 p-0 text-grey-darker text-xs;

  &.active {
    @apply text-support-dark opacity-100;
  }
}
</style>
